import React from 'react'

const Spinners = () => {
    return (
        <div className="spinner-border text-warning" role="status"></div>
    )
}

export default Spinners

